module.exports = __webpack_public_path__ + "img/icon_2_23.2048b17a.png";